export default __webpack_public_path__ + "static/video-poster-7712003ca7f97f0517832eaab285b67e.jpg";